/*
 * BC Cart Morph – v4 (Silent Drawer Update)
 * Uses the official Shopify Ajax Cart API.
 * Fetches updated cart-drawer and cart-icon-bubble sections and silently
 * updates them in the background so they are ready when the user opens the cart.
 */
(function () {
  'use strict';

  function getRoot() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }

  // Sections we need Shopify to render and return
  var SECTIONS = "cart-drawer,cart-icon-bubble";

  document.addEventListener('click', function (e) {

    // --- ADD TO CART ---
    var atcBtn = e.target.closest('.bc-morph-atc');
    if (atcBtn) {
      e.preventDefault();
      e.stopPropagation();
      var wrap = atcBtn.closest('.bc-morph-wrap');
      if (!wrap || atcBtn.disabled || atcBtn.classList.contains('bc-loading')) return;

      var variantId = Number(wrap.getAttribute('data-variant-id'));
      atcBtn.classList.add('bc-loading');

      fetch(getRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: SECTIONS,
          sections_url: window.location.pathname
        })
      })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) {
          console.error('Cart add error:', data.description || data.message);
          return;
        }
        // Success – sync all cards for this variant
        syncAllWrapsForVariant(variantId, 1);
        
        // Update sections silently
        updateSections(data.sections);
      })
      .catch(function (err) { console.error('Add to cart fetch error:', err); })
      .finally(function () { atcBtn.classList.remove('bc-loading'); });
      return;
    }

    // --- PLUS ---
    var plusBtn = e.target.closest('.bc-morph-plus');
    if (plusBtn) {
      e.preventDefault();
      e.stopPropagation();
      var wrap = plusBtn.closest('.bc-morph-wrap');
      if (wrap && !wrap.classList.contains('bc-updating')) changeQty(wrap, 1);
      return;
    }

    // --- MINUS ---
    var minusBtn = e.target.closest('.bc-morph-minus');
    if (minusBtn) {
      e.preventDefault();
      e.stopPropagation();
      var wrap = minusBtn.closest('.bc-morph-wrap');
      if (wrap && !wrap.classList.contains('bc-updating')) changeQty(wrap, -1);
      return;
    }
  });

  function syncAllWrapsForVariant(variantId, nextQty) {
    var wraps = document.querySelectorAll('.bc-morph-wrap[data-variant-id="' + variantId + '"]');
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i];
      w.setAttribute('data-current-qty', String(nextQty));
      var btn = w.querySelector('.bc-morph-btn');
      var qty = w.querySelector('.bc-morph-qty');
      var inp = w.querySelector('.bc-morph-input');
      if (inp) inp.value = String(nextQty);
      if (nextQty > 0) {
        if (btn) btn.style.display = 'none';
        if (qty) qty.style.display = 'flex';
      } else {
        if (btn) btn.style.display = '';
        if (qty) qty.style.display = 'none';
      }
    }
  }

  function changeQty(wrap, delta) {
    var current = parseInt(wrap.getAttribute('data-current-qty')) || 0;
    var next = Math.max(0, current + delta);
    var variantId = wrap.getAttribute('data-variant-id');

    wrap.classList.add('bc-updating');
    var qtyEl = wrap.querySelector('.bc-morph-qty');
    if (qtyEl) qtyEl.style.opacity = '0.5';

    fetch(getRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: next,
        sections: SECTIONS,
        sections_url: window.location.pathname
      })
    })
    .then(function (res) { return res.json(); })
    .then(function (data) {
      syncAllWrapsForVariant(variantId, next);
      updateSections(data.sections);
    })
    .catch(function (err) { console.error('Change qty error:', err); })
    .finally(function () {
      wrap.classList.remove('bc-updating');
      if (qtyEl) qtyEl.style.opacity = '1';
    });
  }

  function updateSections(sections) {
    if (!sections) return;

    // Update Bubble
    if (sections['cart-icon-bubble']) {
      var bubbleEl = document.getElementById('cart-icon-bubble');
      if (bubbleEl) {
        var parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var newContent = parsed.querySelector('.shopify-section');
        if (newContent) bubbleEl.innerHTML = newContent.innerHTML;
      }
    }

    // Update Drawer
    if (sections['cart-drawer']) {
      var drawerEl = document.getElementById('CartDrawer');
      if (drawerEl) {
        var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var newDrawer = parsed.querySelector('#CartDrawer');
        if (newDrawer) {
          drawerEl.innerHTML = newDrawer.innerHTML;
          // Re-bind close event since we replaced innerHTML
          var cartDrawerComponent = document.querySelector('cart-drawer');
          var overlay = drawerEl.querySelector('#CartDrawer-Overlay');
          if (cartDrawerComponent && overlay) {
            overlay.addEventListener('click', cartDrawerComponent.close.bind(cartDrawerComponent));
          }
        }
      }
      
      // Also ensure the empty state class is updated on cart-drawer
      var cartDrawerComponent = document.querySelector('cart-drawer');
      if (cartDrawerComponent) {
        var parsedCartDrawer = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html').querySelector('cart-drawer');
        if (parsedCartDrawer) {
          if (parsedCartDrawer.classList.contains('is-empty')) {
             cartDrawerComponent.classList.add('is-empty');
          } else {
             cartDrawerComponent.classList.remove('is-empty');
          }
        }
      }
    }
  }
})();
